/** Status of the referral program. */
export var ProgramStatus;
(function (ProgramStatus) {
    /** Unknown program status. */
    ProgramStatus["UNKNOWN"] = "UNKNOWN";
    /** Referral program is in a draft state and is being modified. It is not yet active. */
    ProgramStatus["DRAFT"] = "DRAFT";
    /** Referral program is active. */
    ProgramStatus["ACTIVE"] = "ACTIVE";
    /** Referral program is paused. */
    ProgramStatus["PAUSED"] = "PAUSED";
})(ProgramStatus || (ProgramStatus = {}));
export var Type;
(function (Type) {
    /** Unknown reward type. */
    Type["UNKNOWN"] = "UNKNOWN";
    /** Coupon reward type. */
    Type["COUPON"] = "COUPON";
    /** Loyalty points reward type. */
    Type["LOYALTY_POINTS"] = "LOYALTY_POINTS";
    /** No reward type. */
    Type["NOTHING"] = "NOTHING";
})(Type || (Type = {}));
export var DiscountType;
(function (DiscountType) {
    /** Unknown discount type. */
    DiscountType["UNKNOWN"] = "UNKNOWN";
    /** Discount as a fixed amount. */
    DiscountType["FIXED_AMOUNT"] = "FIXED_AMOUNT";
    /** Discount as a percentage. */
    DiscountType["PERCENTAGE"] = "PERCENTAGE";
    /** Free shipping. If `true`, the coupon applies to all items in all `namespaces`. */
    DiscountType["FREE_SHIPPING"] = "FREE_SHIPPING";
})(DiscountType || (DiscountType = {}));
export var Action;
(function (Action) {
    /** Unknown action. */
    Action["UNKNOWN"] = "UNKNOWN";
    /** Referred friend ordered and paid for an order in a store. */
    Action["STORE_ORDER_PLACED"] = "STORE_ORDER_PLACED";
    /** Referred friend ordered and paid for a plan. */
    Action["PLAN_ORDERED"] = "PLAN_ORDERED";
    /** Referred friend ordered and paid for a ticket. */
    Action["TICKET_ORDERED"] = "TICKET_ORDERED";
    /** Referred friend booked and paid for a session. */
    Action["SESSION_BOOKED"] = "SESSION_BOOKED";
    /** Referred friend placed and paid for a restaurant order. */
    Action["RESTAURANT_ORDER_PLACED"] = "RESTAURANT_ORDER_PLACED";
    /** Referred friend joined an online program. */
    Action["ONLINE_PROGRAM_JOINED"] = "ONLINE_PROGRAM_JOINED";
})(Action || (Action = {}));
export var App;
(function (App) {
    /** Unknown app. */
    App["UNKNOWN"] = "UNKNOWN";
    /** Send an email to customers who've placed an order with stores. */
    App["STORES"] = "STORES";
    /** Send an email to customers who've placed an order with pricing plans. */
    App["PRICING_PLANS"] = "PRICING_PLANS";
    /** Send an email to customers who've placed an order with events. */
    App["EVENTS"] = "EVENTS";
    /** Send an email to customers who've placed an order with bookings. */
    App["BOOKINGS"] = "BOOKINGS";
    /** Send an email to customers who've placed an order with restaurants. */
    App["RESTAURANTS"] = "RESTAURANTS";
    /** Send an email to customers who've joined an online program. */
    App["ONLINE_PROGRAMS"] = "ONLINE_PROGRAMS";
})(App || (App = {}));
export var ProviderName;
(function (ProviderName) {
    ProviderName["UNKNOWN"] = "UNKNOWN";
    ProviderName["SBS"] = "SBS";
    ProviderName["LICENSER"] = "LICENSER";
    ProviderName["BASS"] = "BASS";
    ProviderName["RESELLER"] = "RESELLER";
    ProviderName["RECURRING_INVOICES"] = "RECURRING_INVOICES";
})(ProviderName || (ProviderName = {}));
export var IntervalUnit;
(function (IntervalUnit) {
    /** unknown interval unit */
    IntervalUnit["UNKNOWN"] = "UNKNOWN";
    /** day */
    IntervalUnit["DAY"] = "DAY";
    /** week */
    IntervalUnit["WEEK"] = "WEEK";
    /** month */
    IntervalUnit["MONTH"] = "MONTH";
    /** year */
    IntervalUnit["YEAR"] = "YEAR";
})(IntervalUnit || (IntervalUnit = {}));
export var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["UNKNOWN"] = "UNKNOWN";
    SubscriptionStatus["AUTO_RENEW_ON"] = "AUTO_RENEW_ON";
    SubscriptionStatus["AUTO_RENEW_OFF"] = "AUTO_RENEW_OFF";
    SubscriptionStatus["MANUAL_RECURRING"] = "MANUAL_RECURRING";
    SubscriptionStatus["CANCELLED"] = "CANCELLED";
    SubscriptionStatus["TRANSFERRED"] = "TRANSFERRED";
})(SubscriptionStatus || (SubscriptionStatus = {}));
/** Reason for subscription reactivation */
export var ReactivationReasonEnum;
(function (ReactivationReasonEnum) {
    ReactivationReasonEnum["UNKNOWN"] = "UNKNOWN";
    /**
     * Subscription was reactivated due to billing status change from CANCELED to ACTIVE, for example if it was incorrectly
     * canceled because of suspicion of fraud
     */
    ReactivationReasonEnum["BILLING_STATUS_CHANGE"] = "BILLING_STATUS_CHANGE";
    /** Subscription was reactivated after a chargeback dispute */
    ReactivationReasonEnum["REACTIVATED_AFTER_CHARGEBACK"] = "REACTIVATED_AFTER_CHARGEBACK";
})(ReactivationReasonEnum || (ReactivationReasonEnum = {}));
export var Initiator;
(function (Initiator) {
    Initiator["UNKNOWN"] = "UNKNOWN";
    Initiator["USER_REQUESTED"] = "USER_REQUESTED";
    Initiator["APP_MANAGED"] = "APP_MANAGED";
    Initiator["PASSIVE"] = "PASSIVE";
})(Initiator || (Initiator = {}));
export var UnassignReason;
(function (UnassignReason) {
    UnassignReason["UNKNOWN"] = "UNKNOWN";
    UnassignReason["USER_REQUESTED"] = "USER_REQUESTED";
    UnassignReason["REPLACED_BY_ANOTHER_SUBSCRIPTION"] = "REPLACED_BY_ANOTHER_SUBSCRIPTION";
})(UnassignReason || (UnassignReason = {}));
/** Copied from SBS */
export var ContractSwitchType;
(function (ContractSwitchType) {
    ContractSwitchType["NOT_APPLICABLE"] = "NOT_APPLICABLE";
    ContractSwitchType["ADDITIONAL_QUANTITY"] = "ADDITIONAL_QUANTITY";
    ContractSwitchType["CREDIT_UNUSED_PERIOD"] = "CREDIT_UNUSED_PERIOD";
    ContractSwitchType["REFUND_PRICE_DIFF"] = "REFUND_PRICE_DIFF";
    ContractSwitchType["ADJUST_PERIOD_END"] = "ADJUST_PERIOD_END";
    ContractSwitchType["DOWNGRADE_GRACE_PERIOD"] = "DOWNGRADE_GRACE_PERIOD";
    ContractSwitchType["FULL_AMOUNT_PERIOD"] = "FULL_AMOUNT_PERIOD";
    ContractSwitchType["END_OF_PERIOD"] = "END_OF_PERIOD";
    ContractSwitchType["PENDING_CHANGES"] = "PENDING_CHANGES";
    ContractSwitchType["DOWNGRADE_RENEWAL"] = "DOWNGRADE_RENEWAL";
})(ContractSwitchType || (ContractSwitchType = {}));
export var ContractSwitchReason;
(function (ContractSwitchReason) {
    ContractSwitchReason["EXTERNAL_PROVIDER_TRIGGER"] = "EXTERNAL_PROVIDER_TRIGGER";
    ContractSwitchReason["PRICE_INCREASE"] = "PRICE_INCREASE";
})(ContractSwitchReason || (ContractSwitchReason = {}));
/** Reason for Price Increase Trigger */
export var PriceIncreaseTrigger;
(function (PriceIncreaseTrigger) {
    PriceIncreaseTrigger["NEAR_RENEWAL"] = "NEAR_RENEWAL";
    PriceIncreaseTrigger["RECURRING_SUCCESS"] = "RECURRING_SUCCESS";
    PriceIncreaseTrigger["MANUAL"] = "MANUAL";
})(PriceIncreaseTrigger || (PriceIncreaseTrigger = {}));
/** Triggered when a subscription's product is adusted. */
export var ProductAdjustment;
(function (ProductAdjustment) {
    /** flag to show that the ContractSwitchedEvent is not applicable / needed */
    ProductAdjustment["NOT_APPLICABLE"] = "NOT_APPLICABLE";
    /** flag to show that the ContractSwitchedEvent is a Downgrade */
    ProductAdjustment["DOWNGRADE"] = "DOWNGRADE";
})(ProductAdjustment || (ProductAdjustment = {}));
export var V1Type;
(function (V1Type) {
    V1Type["UNSPECIFIED"] = "UNSPECIFIED";
    V1Type["INSTALLED"] = "INSTALLED";
    V1Type["DELETED"] = "DELETED";
})(V1Type || (V1Type = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map